<template>
  <div :class="$style.root">
    <TheHeader @child-checkbox="checkboxValue" />

    <main
      :class="[
        $style.main,
        {
          [$style.menuOpen]: showMenu,
        }
      ]"
    >
      <slot />
    </main>

    <TheFooter
      :class="[{[$style.menuOpen]: showMenu}]"
    />
  </div>
</template>

<script>
import TheHeader from 'components/TheHeader';
import TheFooter from 'components/TheFooter';

export default {
  name: 'TheLayout',
  components: {
    TheHeader,
    TheFooter,
  },
  data() {
    return {
      showMenu: false,
    };
  },
  methods: {
    checkboxValue(showMenu) {
      this.showMenu = showMenu;
    },
  },
};
</script>

<style lang="scss" module>
@import '~styles/variables';
@import '~styles/helpers';

.root {
  display: flex;
  flex-direction: column;
  background-color: $white;
}

.main {
  flex: 1;
  overflow: hidden;
}

.menuOpen {
  @include media('<desktop') {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheLayout.vue